module.exports = __webpack_public_path__ + "img/pcomm.b4cc5e03.jpg";